import { PageController } from '@client/components/_core/layout/PageController';
import { CompensationPaymentTable } from '@client/components/claims/financials/CompensationPaymentTable';
import { CompensationSummary } from '@client/components/claims/financials/CompensationSummary';
import { ExcessPaymentTable } from '@client/components/claims/financials/ExcessPaymentTable';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { trpc } from '@client/trpc/client';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Financials',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <Financials />
        </PageController>
    );
}

function Financials() {
    const orgId = useOrgId();
    const { id, compensationId } = Route.useParams();
    const { data } = trpc.compensation.getCompensation.useQuery({
        id: compensationId,
    });

    const navigate = useNavigate();

    return (
        <>
            <Outlet />

            <CompensationSummary id={compensationId} />

            <CompensationPaymentTable
                compensationId={compensationId}
                description="All items included in this payment transaction"
                onRowClick={(row) => {
                    navigate({
                        to: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/compensation-payments/details/$compensationPaymentId',
                        params: {
                            orgId,
                            id,
                            compensationId,
                            compensationPaymentId: row.id,
                        },
                    });
                }}
            />

            {(data?.payeeType === 'POLICY_HOLDER' ||
                (data?.payeeType === 'SUPPLIER' && data?.TransactionType?.transactionNature === 'INDEMNITY')) && (
                <ExcessPaymentTable
                    compensationId={compensationId}
                    className="mt-6"
                    description="Excesses collected by the supplier or deducted from a settlement payment"
                    onRowClick={(row) =>
                        navigate({
                            to: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/excess-payments/details/$excessPaymentId',
                            params: {
                                orgId,
                                id,
                                compensationId,
                                excessPaymentId: row.id,
                            },
                        })
                    }
                />
            )}
        </>
    );
}
